import React from "react";
import { Box } from "@mui/material";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";

/**
 * Two-option segmented control ("Biomarkers | Labs") for step 2 of the
 * "Sync EHR data" modal (Figma 16771:502493). The app's other switchers are
 * underline tabs or dropdowns, so this pill shape is local to the modal.
 */
export type KeragonView = "biomarkers" | "labs";

type Props = {
  value: KeragonView;
  onChange: (view: KeragonView) => void;
};

const OPTIONS: { key: KeragonView; label: string }[] = [
  { key: "biomarkers", label: "Biomarkers" },
  { key: "labs", label: "Labs" },
];

const KeragonViewToggle = ({ value, onChange }: Props) => {
  const theme: Theme = useTheme();

  return (
    <Box sx={styles.container(theme)} role="tablist">
      {OPTIONS.map((option) => {
        const selected = option.key === value;
        return (
          <Box
            key={option.key}
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(option.key)}
            sx={styles.option(theme, selected)}
          >
            {option.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default KeragonViewToggle;

const styles = {
  container: (theme: Theme) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px",
    borderRadius: "8px",
    backgroundColor: theme.colorTokens.N[40],
    alignSelf: "flex-start",
  }),
  option: (theme: Theme, selected: boolean) => ({
    padding: "4px 16px",
    borderRadius: "6px",
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    lineHeight: "17px",
    cursor: "pointer",
    userSelect: "none" as "none",
    color: selected ? theme.colorTokens.N[100] : theme.colorTokens.N[80],
    backgroundColor: selected ? theme.colors_ds.NEUTRAL_BG_MAIN : "transparent",
    boxShadow: selected ? "0px 2px 4px 0px rgba(0, 0, 0, 0.05)" : "none",
  }),
};
